
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 29.596 22.667"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M18.264 0l-2.93 2.928 6.32 6.318H0v4.172h21.656l-6.322 6.32.354.354 2.576 2.576 11.332-11.334zm0 1.414l9.918 9.92-9.918 9.92-1.516-1.516 7.324-7.32H1v-2.172h23.07l-7.32-7.318z"}})])
          )
        }
      }
    